import Vue from 'vue'
import Router from 'vue-router'
import Routes from '../routes'

Vue.use(Router)

export default new Router({
  routes: Routes,
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js